module.exports = __webpack_public_path__ + "swiss-casinos-logo.svg?ddb70ac1c6fe57f2e46678647a79a3cf";